export const DATE_FORMAT = "DD.MM.YYYY";
export const TIME_FORMAT = "H:mm";

export const TIME_SELECT_DATE_FORMAT = "YYYY-MM-DD";
export const TIME_SELECT_FULL_DATE_FORMAT = "YYYY-MM-DDTHH:mm:ssZ";

export const DATE_OF_BIRTH_API_FORMAT = "YYYY-MM-DD";
